import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'login-1',
        path: `${AUTH_PREFIX_PATH}/login-1`,
        component: React.lazy(() => import('views/auth-views/authentication/login-1')),
    },
    // {
    //     key: 'login-2',
    //     path: `${AUTH_PREFIX_PATH}/login-2`,
    //     component: React.lazy(() => import('views/auth-views/authentication/login-2')),
    // },
    {
        key: 'register-1',
        path: `${AUTH_PREFIX_PATH}/register-1`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    },
    // {
    //     key: 'register-2',
    //     path: `${AUTH_PREFIX_PATH}/register-2`,
    //     component: React.lazy(() => import('views/auth-views/authentication/register-2')),
    // },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'error-page-1',
        path: `${AUTH_PREFIX_PATH}/error-page-1`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    },
    {
        key: 'error-page-2',
        path: `${AUTH_PREFIX_PATH}/error-page-2`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
    },
    {
        key: 'unauthorized',
        path: '/unauthorized',
        component: React.lazy(() => import('views/auth-views/errors/error-page-1/index')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboard`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'appusers',
        path: `${APP_PREFIX_PATH}/app-users`,
        component: React.lazy(() => import('views/app-views/dashboards/app-users/AppUsers')),
    },
    {
        key: 'user.activities',
        path: `${APP_PREFIX_PATH}/app-users-activities/:user_id`,
        component: React.lazy(() => import('views/app-views/dashboards/app-users/user-activities/index')),
    },
    {
        key: 'events',
        path: `${APP_PREFIX_PATH}/events`,
        component: React.lazy(() => import('views/app-views/dashboards/events/Events')),
    },
    {
        key: 'events.eventslist',
        path: `${APP_PREFIX_PATH}/events-list/:event_id`,
        component: React.lazy(() => import('views/app-views/dashboards/events/EventList')),
    },
    {
        key: 'role.master',
        path: `${APP_PREFIX_PATH}/role-master`,
        component: React.lazy(() => import('views/app-views/role-master/RoleMaster')),
    },
    {
        key: 'admin.users',
        path: `${APP_PREFIX_PATH}/admin-users`,
        component: React.lazy(() => import('views/app-views/admin-users/AdminUsers')),
    },
    {
        key: 'event.category',
        path: `${APP_PREFIX_PATH}/event-category`,
        component: React.lazy(() => import('views/app-views/event-category/EventCategory')),
    },
    {
        key: 'challenges.public',
        path: `${APP_PREFIX_PATH}/public-challenges`,
        component: React.lazy(() => import('views/app-views/dashboards/challenges/PublicChallenges')),
    },
    {
        key: 'challenges.team',
        path: `${APP_PREFIX_PATH}/team-challenges`,
        component: React.lazy(() => import('views/app-views/dashboards/challenges/TeamChallenges')),
    },
    {
        key: 'challenges.private',
        path: `${APP_PREFIX_PATH}/private-challenges`,
        component: React.lazy(() => import('views/app-views/dashboards/challenges/PrivateChallenges')),
    },
    {
        key: 'challenges.completed',
        path: `${APP_PREFIX_PATH}/completed-challenges`,
        component: React.lazy(() => import('views/app-views/dashboards/challenges/completed-challenges/CompletedChallenges')),
    },
    {
        key: 'challenges.ongoing',
        path: `${APP_PREFIX_PATH}/challenges-ongoing-list`,
        component: React.lazy(() => import('views/app-views/dashboards/challenges/on-going-challenges/OnGoingChallengesList')),
    },
    {
        key: 'challenges.leaderboard',
        path: `${APP_PREFIX_PATH}/challenges-leaderboard/:challenge_id`,
        component: React.lazy(() => import('views/app-views/dashboards/challenges/challengesLeaderboard/ChallengesLeaderboard')),
    },
    {
        key: 'challenges.eventlist',
        path: `${APP_PREFIX_PATH}/challenges-eventlist/:challenge_id`,
        component: React.lazy(() => import('views/app-views/dashboards/challenges/challenges-event-list/ChallengesEventList')),
    },
    {
        key: 'challenges.teamlist',
        path: `${APP_PREFIX_PATH}/challenges-teamlist/:challenge_id`,
        component: React.lazy(() => import('views/app-views/dashboards/challenges/challenges-event-list/ChallengesTeamList/index')),
    },
    {
        key: 'challenges.leaderboard',
        path: `${APP_PREFIX_PATH}/challenges-leaderboard/:ongoing_id`,
        component: React.lazy(() => import('views/app-views/dashboards/challenges/on-going-challenges/OnogingChallenges')),
    },
    {
        key: 'team.list',
        path: `${APP_PREFIX_PATH}/teams`,
        component: React.lazy(() => import('views/app-views/teams/TeamList')),
    },
    {
        key: 'team.activities',
        path: `${APP_PREFIX_PATH}/teams/user-activities/:teamid`,
        component: React.lazy(() => import('views/app-views/teams/ViewActivities')),
    },
    {
        key: 'team.memberlist',
        path: `${APP_PREFIX_PATH}/teams/:team_id`,
        component: React.lazy(() => import('views/app-views/teams/TeamMemberList')),
    },
    {
        key: 'cause',
        path: `${APP_PREFIX_PATH}/cause`,
        component: React.lazy(() => import('views/app-views/cause/Cause')),
    },
    {
        key: 'cause.causeDonatorsHistory',
        path: `${APP_PREFIX_PATH}/causeDonatorsHistory/:id`,
        component: React.lazy(() => import('views/app-views/cause/Donator-History/CauseDonatorHistory')),
    },
    {
        key: 'cause.causecontributorsHistory',
        path: `${APP_PREFIX_PATH}/causecontributorsHistory/:id`,
        component: React.lazy(() => import('views/app-views/cause/Contributors-History/ContributorsHistory')),
    },
    {
        key: 'offer.management',
        path: `${APP_PREFIX_PATH}/offer-management`,
        component: React.lazy(() => import('views/app-views/dashboards/offer/OfferManagement')),
    },
    // {
    //     key: 'subscription',
    //     path: `${APP_PREFIX_PATH}/subscription`,
    //     component: React.lazy(() => import('views/app-views/subscriptions/Manage-subscriptions')),
    // },
    {
        key: 'Manage.subscriptions',
        path: `${APP_PREFIX_PATH}/manage-subscriptions`,
        component: React.lazy(() => import('views/app-views/manage-subscriptions/ManageSubscriptions')),

    },
    {
        key: 'user.subscription',
        path: `${APP_PREFIX_PATH}/user-subscription`,
        component: React.lazy(() => import('views/app-views/user-subscription/user-subscription')),
    },
    {
        key: 'faq',
        path: `${APP_PREFIX_PATH}/faq`,
        component: React.lazy(() => import('views/app-views/faq/faq')),
    },
    {
        key: 'faq.menu',
        path: `${APP_PREFIX_PATH}/faq-menu-list/:menu_id`,
        component: React.lazy(() => import('views/app-views/faq/faqMenuList')),
    },
    {
        key: 'faq',
        path: `${APP_PREFIX_PATH}/faq-paragraph/:menuId`,
        component: React.lazy(() => import('views/app-views/faq/faqParagraph')),
    },
    {
        key: 'notifications.send',
        path: `${APP_PREFIX_PATH}/send-notification`,
        component: React.lazy(() => import('views/app-views/notifications/Notifications')),
    },
    {
        key: 'notifications.get',
        path: `${APP_PREFIX_PATH}/notification-list`,
        component: React.lazy(() => import('views/app-views/notifications/GetNotifications')),
    },
        {
        key: 'notifications.schedule',
        path: `${APP_PREFIX_PATH}/schedule-notification`,
        component: React.lazy(() => import('views/app-views/notifications/ScheduleNotifications')),
    },
    {
        key: 'pages.profile',
        path: `${APP_PREFIX_PATH}/pages/profile`,
        component: React.lazy(() => import('views/app-views/pages/profile')),
    },
    {
        key: 'coin.master',
        path: `${APP_PREFIX_PATH}/coin-master`,
        component: React.lazy(() => import('views/app-views/coin-master/CoinMaster')),
    },
    {
        key: 'badge.master',
        path: `${APP_PREFIX_PATH}/badge-master`,
        component: React.lazy(() => import('views/app-views/badge-master/BadgeMaster')),
    },
    {
        key: 'download.tracker',
        path: `${APP_PREFIX_PATH}/download-tracker`,
        component: React.lazy(() => import('views/app-views/download-tracker/DownloadTracker')),
    },
    {
        key: 'transaction.success',
        path: `${APP_PREFIX_PATH}/transaction-success`,
        component: React.lazy(() => import('views/app-views/transactions/TransactionSuccess')),
    },
    {
        key: 'transaction.failed',
        path: `${APP_PREFIX_PATH}/transaction-failed`,
        component: React.lazy(() => import('views/app-views/transactions/TransactionFailed')),
    },
    {
        key: 'training.video',
        path: `${APP_PREFIX_PATH}/training-videos`,
        component: React.lazy(() => import('views/app-views/training-video/TrainingVideo')),
    },
    {
        key: 'donation.configuration',
        path: `${APP_PREFIX_PATH}/donation-configuration`,
        component: React.lazy(() => import('views/app-views/configuration/Donationonfiguration')),
    },
    {
        key: 'general.configuration',
        path: `${APP_PREFIX_PATH}/general-configuration`,
        component: React.lazy(() => import('views/app-views/configuration/GeneneralConfiguration')),
    },
    {
        key: 'ads.videos',
        path: `${APP_PREFIX_PATH}/advertisement`,
        component: React.lazy(() => import('views/app-views/ads-video/AdsVideo')),
    },
    {
        key: 'app.version',
        path: `${APP_PREFIX_PATH}/app-version-management`,
        component: React.lazy(() => import('views/app-views/app-version/index')),
    },
    {
        key: 'cancel.subscription',
        path: `${APP_PREFIX_PATH}/cancel-subscription`,
        component: React.lazy(() => import('views/app-views/cancel-subscription/cancel-subscription')),
    },
    {
        key: 'cancel.subscriptionlist',
        path: `${APP_PREFIX_PATH}/app-users-subscription-history/:user_id`,
        component: React.lazy(() => import('views/app-views/dashboards/app-users/subscription-cancel-list/index')),
    },
    {
        key: 'user.activities',
        path: `${APP_PREFIX_PATH}/user-activities`,
        component: React.lazy(() => import('views/app-views/user-activities/index')),
    },
    {
        key: 'reports',
        path: `${APP_PREFIX_PATH}/user-reports`,
        component: React.lazy(() => import('views/app-views/reports/UserReport')),
    },	
	{
		key: "reports.user-metrics",
		path: `${APP_PREFIX_PATH}/user-metrics`,
		component: React.lazy(() =>
		  import("views/app-views/reports/UserMetrics")
		),
    },
    {
    key: "reports.streak-retention",
    path: `${APP_PREFIX_PATH}/streak-retention`,
    component: React.lazy(() =>
        import("views/app-views/reports/StreakRetention")
    ),
    },
    {
        key: 'admin.props',
        path: `${APP_PREFIX_PATH}/admin-props`,
        component: React.lazy(() => import('views/app-views/admin-props/AdminProps')),
    },

	// {
    //     key: 'apps.mail',
    //     path: `${APP_PREFIX_PATH}/apps/mail/*`,
    //     component: React.lazy(() => import('views/app-views/apps/mail')),
    // },
    // {
    //     key: 'apps.chat',
    //     path: `${APP_PREFIX_PATH}/apps/chat/*`,
    //     component: React.lazy(() => import('views/app-views/apps/chat')),
    // },

    // {
    //     key: 'apps.project',
    //     path: `${APP_PREFIX_PATH}/apps/project`,
    //     component: React.lazy(() => import('views/app-views/apps/project')),
    // },
    // {
    //     key: 'apps.project.list',
    //     path: `${APP_PREFIX_PATH}/apps/project/list`,
    //     component: React.lazy(() => import('views/app-views/apps/project/project-list/ProjectList')),
    // },
    // {
    //     key: 'apps.project.scrumboard',
    //     path: `${APP_PREFIX_PATH}/apps/project/scrumboard`,
    //     component: React.lazy(() => import('views/app-views/apps/project/scrumboard')),
    // },
    // {
    //     key: 'apps.ecommerce',
    //     path: `${APP_PREFIX_PATH}/apps/ecommerce`,
    //     component: React.lazy(() => import('views/app-views/apps/e-commerce')),
    // },
    // {
    //     key: 'apps.ecommerce.add-product',
    //     path: `${APP_PREFIX_PATH}/apps/ecommerce/add-product`,
    //     component: React.lazy(() => import('views/app-views/apps/e-commerce/add-product')),
    // },
    // {
    //     key: 'apps.ecommerce.edit-product',
    //     path: `${APP_PREFIX_PATH}/apps/ecommerce/edit-product/:id`,
    //     component: React.lazy(() => import('views/app-views/apps/e-commerce/edit-product')),
    // },
    // {
    //     key: 'apps.ecommerce.product-list',
    //     path: `${APP_PREFIX_PATH}/apps/ecommerce/product-list`,
    //     component: React.lazy(() => import('views/app-views/apps/e-commerce/product-list')),
    // },
    // {
    //     key: 'apps.ecommerce.orders',
    //     path: `${APP_PREFIX_PATH}/apps/ecommerce/orders`,
    //     component: React.lazy(() => import('views/app-views/apps/e-commerce/orders')),
    // },

    // {
    //     key: 'login-1',
    //     path: `${APP_PREFIX_PATH}/login-1`,
    //     component: React.lazy(() => import('views/auth-views/authentication/login-1')),
    //     meta: {
    //         blankLayout: true
    //     }
    // },
    // {
    //     key: 'login-2',
    //     path: `${APP_PREFIX_PATH}/login-2`,
    //     component: React.lazy(() => import('views/auth-views/authentication/login-2')),
    //     meta: {
    //         blankLayout: true
    //     }
    // },
    // {
    //     key: 'register-1',
    //     path: `${APP_PREFIX_PATH}/register-1`,
    //     component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    //     meta: {
    //         blankLayout: true
    //     }
    // },
    // {
    //     key: 'register-2',
    //     path: `${APP_PREFIX_PATH}/register-2`,
    //     component: React.lazy(() => import('views/auth-views/authentication/register-2')),
    //     meta: {
    //         blankLayout: true
    //     }
    // },
    // {
    //     key: 'forgot-password',
    //     path: `${APP_PREFIX_PATH}/forgot-password`,
    //     component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    //     meta: {
    //         blankLayout: true
    //     }
    // },
    // {
    //     key: 'error-page-1',
    //     path: `${APP_PREFIX_PATH}/error-page-1`,
    //     component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    //     meta: {
    //         blankLayout: true
    //     }
    // },
    // {
    //     key: 'error-page-2',
    //     path: `${APP_PREFIX_PATH}/error-page-2`,
    //     component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
    //     meta: {
    //         blankLayout: true
    //     }
    // },
    // {
    //     key: 'pages',
    //     path: `${APP_PREFIX_PATH}/pages`,
    //     component: React.lazy(() => import('views/app-views/pages')),
    // },

    // {
    //     key: 'pages.invoice',
    //     path: `${APP_PREFIX_PATH}/pages/invoice`,
    //     component: React.lazy(() => import('views/app-views/pages/invoice')),
    // },
    // {
    //     key: 'pages.pricing',
    //     path: `${APP_PREFIX_PATH}/pages/pricing`,
    //     component: React.lazy(() => import('views/app-views/pages/pricing')),
    // },
    // {
    //     key: 'pages.faq',
    //     path: `${APP_PREFIX_PATH}/pages/faq`,
    //     component: React.lazy(() => import('views/app-views/pages/faq')),
    // },
    // {
    //     key: 'settings',
    //     path: `${APP_PREFIX_PATH}/settings*`,
    //     component: React.lazy(() => import('views/app-views/pages/setting')),
    // },
    // {
    //     key: 'pages.user-list',
    //     path: `${APP_PREFIX_PATH}/pages/user-list`,
    //     component: React.lazy(() => import('views/app-views/pages/user-list')),
    // }
]